import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { TypeOfTreatmentEntity } from '../../../../entities/mdqx/doctor/type-of-treatment.entity';
import { TypeOfTreatmentActions } from '../../../actions/mdqx/doctor/type-of-treatment.actions';

export const TYPE_OF_TREATMENT_FEATURE_KEY = 'typeOfTreatment';

export interface TypeOfTreatmentState extends EntityState<TypeOfTreatmentEntity> {
    fetched: boolean;
    // latestUpdatedAt: Date | null;
}

const adapter = createEntityAdapter<TypeOfTreatmentEntity>({
    selectId: (Entity) => Entity.Id,
    sortComparer: (a, b) => a.Name.localeCompare(b.Name),
});

const initialState: TypeOfTreatmentState = adapter.getInitialState({
    fetched: false,
    // latestUpdatedAt: null,
});

/* ############# */
/* ## REDUCER ## */
/* ############# */

export const typeOfTreatmentReducer = createReducer(
    initialState,
    on(TypeOfTreatmentActions.loadSuccess, (state, { Payload }) =>
        adapter.setAll(Payload, {
            ...state,
            fetched: true,
        }),
    ),
    on(TypeOfTreatmentActions.putSuccess, (state, { Payload }) =>
        adapter.setMany(Payload, {
            ...state,
        }),
    ),
    on(TypeOfTreatmentActions.changeSuccess, (state, { Payload }) =>
        adapter.setOne(Payload, {
            ...state,
        }),
    ),
    on(TypeOfTreatmentActions.deleteSuccess, (state, { Payload }) =>
        adapter.removeOne(Payload, {
            ...state,
        }),
    ),
);

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectAllTypeOfTreatment = selectAll;
export const selectTypeOfTreatmentEntities = selectEntities;

export const selectTypeOfTreatmentFetched = (state: TypeOfTreatmentState) => state.fetched;
// export const selectTypeOfTreatmentLatestUpdatedAt = (state: TypeOfTreatmentState) => state.latestUpdatedAt;
